import { useQuery } from "@tanstack/react-query";
import React from "react";
import { ApiList } from "../../Api/ApiList";
import { fetch_data_from_api_from_query } from "../../Api/APICalls";
import { createSearchURLParams, get_property_settings } from "../Helper";
import { get_bool_value, get_search_params } from "../../utils";
import {  Link } from "react-router-dom";



export default function InventorDropdownMenu({linkName}) {

  let show_investor_module_frontend = get_property_settings("show_investor_module_frontend")
  show_investor_module_frontend = get_bool_value(show_investor_module_frontend)
 
  const search_params = get_search_params()

 

  const investor_query_response = useQuery({
    queryKey: [ApiList.Investor],
    queryFn: () => fetch_data_from_api_from_query(ApiList.Investor, ApiList.Investor, {}),
    enabled: !!show_investor_module_frontend,
  })

 //${location.pathname.replace("/","")}

  if(!investor_query_response.data || !Array.isArray(investor_query_response.data)) return null

  return (
    <li className="dropdown single-menu single-menu-dropdown-li ">
    <Link className=" main-home-menu-link" to={`${createSearchURLParams(`home`, {...search_params, investor_id: '0'})}`}>{linkName || "Investor"}</Link>
    
    <ul className="sub-menu">
      {
        investor_query_response.data?.map(investor => (
          <li className="sub-menu-list" key={investor?.id}>
          <Link className="categoryLinks" to={`${createSearchURLParams(`home`, {...search_params, investor_id: investor?.id})}`}>
            {investor?.title}
          </Link>
        </li>
        ))
      }
        
    </ul>
    </li>
    
  );
}
